import React, { Component, useState } from 'react'; 
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Modal from './CustomModal'
import ModalHeader from './ModalHeader'
import ModalBody from './ModalBody'
import ModalFooter from '../Components/ModalFooter'
import swal from '@sweetalert/with-react';
import { connect } from 'react-redux'
import { uploadFileforAdvanceDocuments } from './../store/actions/fileActions'
import { postMapAdvanceDocumentIDsToPO } from './../store/actions/poDetailsActions'
import env from '../ENV';
const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

class UploadPopUpPoAcceptance extends Component {

    constructor(props) {
        super(props);
        this.state={
            reviseForm:{
                file:[],
                comment:""
            },
            DocumentIdMap: {
                Performa: 41,
                BarChart: 42,
                BG: 43,
                Others: 44
            },
            DocumentTypeMapper: [],
            poID: this.props.poID
            
        }
        
        this.modal= this.modal.bind(this); 
        
    }

   
    modal() {
        this.props.toggleUploadPOAcceptanceModal(false)
        
    } 

    handleFileInput =(event, documentTypeId)=>{
        let reviseForm = this.state.reviseForm
        let DocumentTypeMapper = this.state.DocumentTypeMapper
        
        reviseForm.file.push(event.target.files[0])
        DocumentTypeMapper.push(documentTypeId)
        // reviseForm.file = fileList
        this.setState({reviseForm, DocumentTypeMapper});
        console.log(this.state.reviseForm, this.state.DocumentTypeMapper, 'file dekh')
    }

    formChange = (e)=>{
        console.log("Event",e.target.value);
        let reviseForm = this.state.reviseForm
        reviseForm.comment = e.target.value;
        this.setState({reviseForm});
    }
    
    formSaveAction = async ()=>{
        this.modal(false);
    }
    onclickUpload = async(uploadID,poID) =>  {
        console.log(this.state.selectedFile)
        console.log("uploadID",uploadID, "POID=", poID)
      
        if(this.state.selectedFile.length<1){
          swal("Please upload some valid document",{icon:"error"})
          
          return false;
        }
          swal("Document is uploading...",{button:false,icon:"info"})
            //   var result = 
              await this.props.uploadFileforPOAcceptance(this.state.selectedFile, '', poID,'','')
            //   console.log("result", result.results)
            //   var versionId = result.results[0].VersionId
            //   var documentId = result.results[0].DocumentId
            //   await this.props.postMapPOAcceptanceToPO(versionId,documentId,poID)
              // await this.props.uploadFileforPOAcceptanceAdvance(this.state.selectedFile,uploadID);
      }

    // handle file upload
    onclickUpload = async (uploadID, poID) => {
        console.log(this.state.selectedFile)
        console.log("uploadID", uploadID, "POID=", poID)

        if (this.state.reviseForm.file.length < 1) {
            swal("Please upload some valid document", { icon: "error" })

            return false;
        }
        swal("Document is uploading...", { button: false, icon: "info" })
        var result = await this.props.uploadFileforAdvanceDocuments(this.state.reviseForm.file)
        console.log("result", result.results)

        result.results.map(async(el, index) => {
            await this.props.postMapAdvanceDocumentIDsToPO(
                el.DocumentId,
                this.state.poID,
                this.state.DocumentTypeMapper[index],
                1
            )
            console.log('success', index)
        })


        // var versionId = result.results[0].VersionId
        // var documentId = result.results[0].DocumentId
        // await this.props.postMapPOAcceptanceDocumentsToPO(versionId, documentId, poID)
    }

 render(){
    
    console.log(this.state.poID, 'poID')

 return(
     <div>
      
        <div>
        <Modal  isOpen={this.props.action} >
            <div className={"modal-bg" + (this.props.action === 'false'  ? 'open' : '')}>
                <div className={"modal-bg" + (this.state.OpenVersionModal == true  ? 'open' : '')}>
                    <div className="modalheads">
                        <ModalHeader HeaderStyle="modal-header modalheaderWide">
                            <div className="modal-text"><h4 >Upload Documents</h4></div>
                            <button type="button" className="close" aria-label="Close" onClick={this.modal} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </ModalHeader>
                    </div>
                <ModalBody Style="modal-body modalbodysWide">
                    <div className="row ">
                        <div className="col-8"></div>
                        <div className="col-4 pb-2">
                            {/* <DropdownFlat defaultopt="-Select-"  data={this.state.Date} actions={this.handleSelect} keyObjName={"value"} valueObjName={"label"} /> */}
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-4 mt-2">
                            Proforma Invoice(Required): 
                        </div>
                        <div className="col-sm-6 mt-2">
                            <input type="file" className="form-control-file" name="" onChange={(e) => {this.handleFileInput(e, this.state.DocumentIdMap.Performa)}} id="exampleFormControlFile2"/>
                        </div>
                        <div className="col-sm-4 mt-2">
                            Bar Charts / Delivery Schedule(Required): 
                        </div>
                        <div className="col-sm-6 mt-3">
                            <input type="file" className="form-control-file" name="" onChange={(e) => {this.handleFileInput(e, this.state.DocumentIdMap.BarChart)}} id="exampleFormControlFile2"/>
                        </div>
                        <div className="col-sm-4 mt-2">
                            Bank Guarantee/Corporate Guarantee/Post-Dated Cheque(Required): 
                        </div>
                        <div className="col-sm-6 mt-2">
                            <input type="file" className="form-control-file" name="" onChange={(e) => {this.handleFileInput(e, this.state.DocumentIdMap.BG)}} id="exampleFormControlFile2"/>
                        </div>
                        <div className="col-sm-4 mt-2">
                            Other Documents: 
                        </div>
                        <div className="col-sm-6 mt-2">
                            <input type="file" className="form-control-file" name="" onChange={(e) => {this.handleFileInput(e, this.state.DocumentIdMap.Others)}} id="exampleFormControlFile2"/>
                        </div>
                    </div>
                </ModalBody>
                </div>
                <div className="">    
                    <ModalFooter FooterStyle="modal-footer modalfooterWide">
                        <div>
                            <button className="btn2 btn-sms1 mt-2 ml-2 float-right" type="submit" onClick={() => {this.onclickUpload()}}>Submit for Approval</button> 
                            <button className="btn2 btn-sms1 mt-2 ml-2 float-right" type="submit">Save As Draft</button> 
                            <button className="btn2 btn-sms1 mt-2 ml-2 " onClick={this.modal} type="submit">Close</button> 
                        </div>
                    </ModalFooter>
                </div>
            </div>
        </Modal>         
        </div>
        
    </div>
       
     
 )
 
  }
}
 

const mapStateToProps  = (state) => ({ file: state.file, poDetails: state.poDetails })
export default connect(mapStateToProps, { uploadFileforAdvanceDocuments, postMapAdvanceDocumentIDsToPO })(UploadPopUpPoAcceptance)
